import { IPatientDemographicsState } from '../features/patientDemographics/store/patientDemographics.types'
import { ITripInformationState } from '../features/tripInformation/store/tripInformation.types'

export const updateSignatureTerms = (
  term: string,
  patientDemographics: IPatientDemographicsState,
  tripInformation: ITripInformationState
): string => {
  if (!term) {
    return ''
  }
  return term
    .replaceAll('|$pt.fname$|', patientDemographics.firstName ? patientDemographics.firstName : '')
    .replaceAll('|$pt.lname$|', patientDemographics.lastName ? patientDemographics.lastName : '')
    .replaceAll('|$pt.addr1$|', patientDemographics.address1 ? patientDemographics.address1 : '')
    .replaceAll('|$pt.addr2$|', patientDemographics.address2 ? patientDemographics.address2 : '')
    .replaceAll('|$pt.city$|', patientDemographics.city ? patientDemographics.city.name : '')
    .replaceAll('|$pt.state$|', patientDemographics.state ? `${patientDemographics.state?.name}` : '')
    .replaceAll('|$pt.zip$| ', patientDemographics.zipCode ? `${patientDemographics.zipCode}` : '')
    .replaceAll(
      '|$pt.phone$|',
      patientDemographics.phoneDetails.length > 0 ? `${patientDemographics.phoneDetails[0]?.number}` : ''
    )
    .replaceAll('|$pt.dob$|', patientDemographics.dOB ? `${patientDemographics.dOB}` : '')
    .replaceAll('|$PR_MAIN-BASE_ID$|', tripInformation.base ? `${tripInformation.base?.name}` : '')
    .replaceAll('|$PR_MAIN-UNIT_IDs$|', tripInformation.unit ? `${tripInformation.unit?.name}` : '')
    .replaceAll(/\|\$[1-7]\$\|/g, '')
    .replaceAll(/\|\$(?:-([1-9]|[1-9][0-9]{1,3}|10000)|2|3):[^\|$]*(?:['][^\|$]*)*\$\|/g, '')
}
